'use strict';

(function($) {

    var pluginName = 'kumsalTranslationSelector';

    // plugin setup
    $.fn[pluginName] = function(options) {
        if ($(this).length === 0) {
            return;
        }

        // global variables
        var selector = this;

        var Plugin = {
            section: null,
            options:{
                selector : null,
            },
            language: {
                key: null,
                name: null,
            },
            changeLanguage: function () {
                selector.find('a[data-toggle=dropdown] span').text(selector.language.name);
                selector.section.find('.translation-section[data-language='+selector.language.key+']').removeClass('d-none');
                selector.section.find('.translation-section[data-language!='+selector.language.key+']').addClass('d-none');
            },
            init: function()
            {
                selector.find('.nav-link').click(function () {
                    selector.language = {
                        key: $(this).data('language'),
                        name: $(this).text(),
                    };
                    selector.changeLanguage();
                });

                return selector;
            },
        };

        /**
         * Public API methods can be used directly by datatable
         */
        $.each(Plugin, function(funcName, func) {
            selector[funcName] = func;
        });

        if (!selector.isInit){
            selector.options = $(selector).data();

            selector.section = $('[data-translate='+ selector.options.selector +']');

            selector.init();
        }

        return selector;
    };

}(jQuery));

$('document').ready(function () {

    $(".translate-btn-group").each(function( index ) {

        $(this).kumsalTranslationSelector();
    });
});